"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const featureFlag_1 = require("../../featureFlag");
class Config {
    constructor() {
        this.bankId = 'OK_ES';
        this.language = 'es-ES';
        this.domain = 'openbank.es';
        this.featureFlagPlatform = featureFlag_1.FeatureFlagPlatform.WEB;
        this.getLoginDomain = () => window.LOGIN_DOMAIN;
        this.getMiddlewareBaseHost = () => window.MIDDLEWARE_BASE_HOST;
        this.getTranslationsServiceHost = () => this.getMiddlewareBaseHost() + '/mb-api-translations';
        this.getFeatureFlagServiceHost = () => this.getMiddlewareBaseHost() + '/mb-api-feature-flag';
        this.getFeatureFlagConfig = () => {
            return {
                bank: featureFlag_1.FeatureFlagBanks.BANK_ES,
                platform: featureFlag_1.FeatureFlagPlatform.WEB,
                featureFlagServiceHost: this.getFeatureFlagServiceHost(),
            };
        };
        this.getCookieDomain = () => (window.ENVIRONMENT !== 'prod' ? `.${window.ENVIRONMENT}${this.domain}` : this.domain);
    }
}
exports.Config = Config;
//# sourceMappingURL=config.js.map